export const detectEmployeeContributionIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE AUTO PROCESS TDS
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of|disable|turn off)\s+(the\s+)?(auto process tds)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("auto") &&
        cleaned.includes("tds")
    ) {
        return {
            intent: "delete_auto_process_tds",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE AUTO PROCESS TDS
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define|enable|turn on)\s+(a\s+|new\s+)?(auto process tds)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("auto") &&
        cleaned.includes("tds")
    ) {
        return {
            intent: "create_auto_process_tds",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
